export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(Math.round(isFinite(n) ? n : 0));

export function repayment({ price, deposit, rate, termYears, interestOnly }) {
  const principal = Math.max(price - deposit, 0);
  const months = termYears * 12;
  const r = rate / 100 / 12;
  let monthly;
  if (principal <= 0) {
    monthly = 0;
  } else if (interestOnly) {
    monthly = principal * r;
  } else if (r === 0) {
    monthly = principal / months;
  } else {
    const f = Math.pow(1 + r, months);
    monthly = (principal * r * f) / (f - 1);
  }
  const totalRepayable = monthly * months + (interestOnly ? principal : 0);
  const totalInterest = Math.max(totalRepayable - principal, 0);
  const ltv = price > 0 ? (principal / price) * 100 : 0;
  return { monthly, principal, totalInterest, totalRepayable, ltv };
}

const STANDARD_BANDS = [
  [125000, 0],
  [250000, 0.02],
  [925000, 0.05],
  [1500000, 0.1],
  [Infinity, 0.12],
];

function bandedTax(price, bands, surcharge = 0) {
  let tax = 0;
  let lower = 0;
  for (const [cap, rate] of bands) {
    if (price > lower) {
      tax += (Math.min(price, cap) - lower) * (rate + surcharge);
      lower = cap;
    } else break;
  }
  return tax;
}

export function stampDuty(price, buyerType) {
  if (price <= 0) return { tax: 0, effectiveRate: 0 };
  let tax;
  if (buyerType === "first-time" && price <= 500000) {
    const ftbBands = [
      [300000, 0],
      [Infinity, 0.05],
    ];
    tax = bandedTax(price, ftbBands);
  } else if (buyerType === "additional") {
    tax = bandedTax(price, STANDARD_BANDS, 0.05);
  } else {
    tax = bandedTax(price, STANDARD_BANDS);
  }
  return { tax, effectiveRate: (tax / price) * 100 };
}

export function borrowingEstimate({ income, secondIncome, deposit }) {
  const totalIncome = (income || 0) + (secondIncome || 0);
  const borrowing = totalIncome * 4.5;
  const maxPrice = borrowing + (deposit || 0);
  const ltv = maxPrice > 0 ? (borrowing / maxPrice) * 100 : 0;
  return { borrowing, maxPrice, ltv };
}
